/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* Thunks */

import draftApi from '../../../api/draft.api';
import { createFOAsyncThunk } from '../../helpers/thunk.helpers';

/**
 * Fetches the submission rows from the server
 */
export const fetchSubmissionRows = createFOAsyncThunk('submissions/fetchSubmissionRows', async (arg) => {
  const { procedure, initialSubmissionProcedure, pagingSortingAndFiltering } = arg;

  const submissionsPage = await draftApi.fetchSubmissionRows(
    procedure,
    initialSubmissionProcedure,
    pagingSortingAndFiltering,
  );
  return { submissionsPage };
});
